import { render } from "./RouteCard.vue?vue&type=template&id=3b82ac8e&scoped=true&lang=pug"
import script from "./RouteCard.vue?vue&type=script&lang=ts"
export * from "./RouteCard.vue?vue&type=script&lang=ts"

import "./RouteCard.vue?vue&type=style&index=0&id=3b82ac8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b82ac8e"

export default script